import { useEffect, useState } from 'react';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import { AutocompleteSearch } from 'types/Filters';
import listOrganizationLabels from 'api/Organization/listOrganizationLabels';

interface NodeProps {
    label: string;
    organizationUri: string;
    __typename: string;
}
export default function useOrganizationLabels(count: number) {
    const client = useClient() as unknown as {
        query: (query: any) => Promise<any>;
    };
    const { openAlert } = useAlert();

    const [loadingLabels, setLoading] = useState(true);
    const [labels, setLabels] = useState<AutocompleteSearch[]>([]);
    const [countTotal, setCountTotal] = useState(0);
    useEffect(() => {
        const filter = {
            page: 1,
            pageSize: count,
            term: '',
            roles: ['Admin', 'Owner', 'Member'],
            sort: [],
        };

        const fetchData = async () => {
            // We want to avoid that the function is called when a new search has been done, the number should stay with the value of the total organizations
            setCountTotal(count);
            try {
                setLoading(true);
                const response = await client?.query(
                    listOrganizationLabels(filter),
                );
                if (!response.errors) {
                    setLabels(
                        response.data.listOrganizations.nodes.map(
                            (node: NodeProps) => ({
                                label: node.label,
                                uri: node.organizationUri,
                                type: node.__typename.toLowerCase(),
                            }),
                        ),
                    );
                } else {
                    openAlert({
                        message: `Something went wrong... Could not retrieve organizations ${response.errors[0]?.message}`,
                        severity: 'alert',
                    });
                }
            } catch (error: any) {
                openAlert({
                    message: `An error occurred while fetching organizations ${error?.message}`,
                    severity: 'alert',
                });
            } finally {
                setLoading(false);
            }
        };

        if (client && count > 0 && count > countTotal) {
            fetchData();
        }
    }, [client, count, countTotal]);

    return { labels, loadingLabels };
}
